//burger function
const burger = document.querySelector('.header__menu-btn');
const nav = document.querySelector('.header__nav');
const menuLink = document.querySelector('.header__menu');

function toggleBurger() {
    burger.addEventListener('click', (event) => {
        burger.classList.toggle('active');
        nav.classList.toggle('active');
        menuLink.classList.toggle('--active');
        document.body.classList.toggle('noscroll');
    });
    nav.addEventListener('click', (event) => {
        if (window.innerWidth <= 768 && event.target.classList.contains('nav__list-link')) {
            burger.classList.toggle('active');
            nav.classList.toggle('active');
            menuLink.classList.toggle('--active');
            document.body.classList.toggle('noscroll');
        }
    });
}
menuLink.addEventListener('click', (event) => {
    if (menuLink.classList.contains('--active')) {
        event.preventDefault();
    }
});
toggleBurger();

//products modified to include IMG content
const menuItems = [{
    name: "Irish coffee",
    description: "Fragrant black coffee with Jameson Irish whiskey and whipped milk",
    price: "7.00",
    category: "coffee",
    photo: "assets/img/coffee-1.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Kahlua coffee",
    description: "Classic coffee with milk and Kahlua liqueur under a cap of frothed milk",
    price: "7.00",
    category: "coffee",
    photo: "assets/img/coffee-2.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Honey raf",
    description: "Espresso with frothed milk, cream and aromatic honey",
    price: "5.50",
    category: "coffee",
    photo: "assets/img/coffee-3.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Ice cappuccino",
    description: "Cappuccino with soft thick foam in summer version with ice",
    price: "5.00",
    category: "coffee",
    photo: "assets/img/coffee-4.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Espresso",
    description: "Classic black coffee",
    price: "4.50",
    category: "coffee",
    photo: "assets/img/coffee-5.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Latte",
    description: "Espresso coffee with the addition of steamed milk and dense milk foam",
    price: "5.50",
    category: "coffee",
    photo: "assets/img/coffee-6.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Latte macchiato",
    description: "Espresso with frothed milk and chocolate",
    price: "5.50",
    category: "coffee",
    photo: "assets/img/coffee-7.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Coffee with cognac",
    description: "Fragrant black coffee with cognac and whipped cream",
    price: "6.50",
    category: "coffee",
    photo: "assets/img/coffee-8.jpg",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Cinnamon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Moroccan",
    description: "Fragrant black tea with the addition of tangerine, cinnamon, honey, lemon and mint",
    price: "4.50",
    category: "tea",
    photo: "assets/img/tea-1.png",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Lemon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Ginger",
    description: "Original black tea with fresh ginger, lemon and honey",
    price: "5.00",
    category: "tea",
    photo: "assets/img/tea-2.png",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Lemon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Cranberry",
    description: "Invigorating black tea with cranberry and honey",
    price: "5.00",
    category: "tea",
    photo: "assets/img/tea-3.png",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Lemon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Sea buckthorn",
    description: "Toning sweet black tea with sea buckthorn, fresh thyme and cinnamon",
    price: "5.50",
    category: "tea",
    photo: "assets/img/tea-4.png",
    sizes: {
        s: {
            size: "200 ml",
            "add-price": "0.00"
        },
        m: {
            size: "300 ml",
            "add-price": "0.50"
        },
        l: {
            size: "400 ml",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Sugar",
        "add-price": "0.50"
    }, {
        name: "Lemon",
        "add-price": "0.50"
    }, {
        name: "Syrup",
        "add-price": "0.50"
    }]
}, {
    name: "Marble cheesecake",
    description: "Philadelphia cheese with lemon zest on a light sponge cake and red currant jam",
    price: "3.50",
    category: "dessert",
    photo: "assets/img/dessert-1.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Red velvet",
    description: "Layer cake with cream cheese frosting",
    price: "4.00",
    category: "dessert",
    photo: "assets/img/dessert-2.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Cheesecakes",
    description: "Soft cottage cheese pancakes with sour cream and fresh berries and sprinkled with powdered sugar",
    price: "4.50",
    category: "dessert",
    photo: "assets/img/dessert-3.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Creme brulee",
    description: "Delicate creamy dessert in a caramel basket with wild berries",
    price: "4.00",
    category: "dessert",
    photo: "assets/img/dessert-4.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Pancakes",
    description: "Tender pancakes with strawberry jam and fresh strawberries",
    price: "4.50",
    category: "dessert",
    photo: "assets/img/dessert-5.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Honey cake",
    description: "Classic honey cake with delicate custard",
    price: "4.50",
    category: "dessert",
    photo: "assets/img/dessert-6.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Chocolate cake",
    description: "Cake with hot chocolate filling and nuts with dried apricots",
    price: "5.50",
    category: "dessert",
    photo: "assets/img/dessert-7.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}, {
    name: "Black forest",
    description: "A combination of thin sponge cake with cherry jam and light chocolate mousse",
    price: "6.50",
    category: "dessert",
    photo: "assets/img/dessert-8.png",
    sizes: {
        s: {
            size: "50 g",
            "add-price": "0.00"
        },
        m: {
            size: "100 g",
            "add-price": "0.50"
        },
        l: {
            size: "200 g",
            "add-price": "1.00"
        }
    },
    additives: [{
        name: "Berries",
        "add-price": "0.50"
    }, {
        name: "Nuts",
        "add-price": "0.50"
    }, {
        name: "Jam",
        "add-price": "0.50"
    }]
}]

//create card item
const createProductCard = (item) => {
    const listItem = document.createElement('li');
    listItem.className = 'menu__list-item';

    const article = document.createElement('article');
    article.className = 'menu__card';

    const preview = document.createElement('div');
    preview.className = 'menu__card-preview';

    const img = document.createElement('img');
    img.className = 'menu__card-preview-img';
    img.src = item.photo;
    img.alt = item.name;

    const description = document.createElement('div');
    description.className = 'menu__card-description';

    const title = document.createElement('h2');
    title.className = 'menu__card-title';
    title.textContent = item.name;

    const text = document.createElement('p');
    text.className = 'menu__card-text';
    text.textContent = item.description;

    const price = document.createElement('span');
    price.className = 'menu__card-price';
    price.textContent = `$${item.price}`;

    preview.appendChild(img);
    description.appendChild(title);
    description.appendChild(text);
    description.appendChild(price);

    article.appendChild(preview);
    article.appendChild(description);

    listItem.appendChild(article);

    return listItem;
};

//animate transition
const fadeIn = (element) => {
    element.style.opacity = 1;
};

//category sort and display
const menuList = document.querySelector('.menu__list');
let allMenuItems = [...menuItems];
let currentCategory = 'coffee';
let itemsPerPage = 8;

function showProductsByCategory(category) {
    currentCategory = category;
    menuList.innerHTML = '';

    const filteredItems = allMenuItems.filter((menuItem) => menuItem.category === category);

    filteredItems.slice(0, itemsPerPage).forEach((menuItem) => {
        const menuItemElement = createProductCard(menuItem);
        menuList.appendChild(menuItemElement);
        requestAnimationFrame(() => fadeIn(menuItemElement));
    });

    const itemsLeft = filteredItems.length - itemsPerPage;

    if (itemsLeft > 0 && filteredItems.length > itemsPerPage && filteredItems.length > 4) {
        const existingLoaderButton = document.querySelector('.menu__add');
        if (!existingLoaderButton) {
            const loaderButton = document.createElement('button');
            loaderButton.classList.add('menu__add');
            loaderButton.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="refresh">
                <path id="Ellipse" d="M21.8883 13.5C21.1645 18.3113 17.013 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C16.1006 2 19.6248 4.46819 21.1679 8" stroke="#403F3D" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Ellipse_2" d="M17 8H21.4C21.7314 8 22 7.73137 22 7.4V3" stroke="#403F3D" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </svg>`;
            loaderButton.addEventListener('click', addMoreCards);
            const menuInner = document.querySelector('.menu__inner');
            menuInner.appendChild(loaderButton);
        }
    }
    initCardEventListeners();
}

function addMoreCards() {
    const filteredItems = allMenuItems.filter((menuItem) => menuItem.category === currentCategory);
    const itemsLeft = filteredItems.length - menuList.children.length;

    const itemsToShow = filteredItems.slice(menuList.children.length, menuList.children.length + itemsPerPage);

    itemsToShow.forEach((menuItem) => {
        const menuItemElement = createProductCard(menuItem);
        menuList.appendChild(menuItemElement);
        requestAnimationFrame(() => fadeIn(menuItemElement));
    });

    if (itemsLeft <= itemsPerPage) {
        const loaderButton = document.querySelector('.menu__add');
        if (loaderButton) {
            loaderButton.remove();
        }
    }
}

function adjustItemsPerPage() {
    const filteredItems = allMenuItems.filter((menuItem) => menuItem.category === currentCategory);

    if (window.innerWidth <= 768 && itemsPerPage === 8) {
        itemsPerPage = 4;

        // Check if the number of items in the category is less than or equal to the new itemsPerPage
        const itemsInCategory = filteredItems.length;
        if (itemsInCategory <= itemsPerPage) {
            const loaderButton = document.querySelector('.menu__add');
            if (loaderButton) {
                loaderButton.remove();
            }
        }

        showProductsByCategory(currentCategory);
    } else if (window.innerWidth > 768 && itemsPerPage === 4) {
        itemsPerPage = 8;
        showProductsByCategory(currentCategory);
    }
}

window.addEventListener('resize', adjustItemsPerPage);

showProductsByCategory(currentCategory);

//                          Button handlers
const coffeeBtn = document.querySelector('.menu__btn:nth-child(1)');
const teaBtn = document.querySelector('.menu__btn:nth-child(2)');
const dessertBtn = document.querySelector('.menu__btn:nth-child(3)');

// display categories
const showCoffeeMenu = () => {
    currentCategory = 'coffee';
    showProductsByCategory(currentCategory);
    setActiveButton(coffeeBtn);
};

const showTeaMenu = () => {
    currentCategory = 'tea';
    showProductsByCategory(currentCategory);
    setActiveButton(teaBtn);
};

const showDessertMenu = () => {
    currentCategory = 'dessert';
    showProductsByCategory(currentCategory);
    setActiveButton(dessertBtn);
};

const setActiveButton = (button) => {
    const buttons = [coffeeBtn, teaBtn, dessertBtn];
    buttons.forEach((btn) => btn.classList.remove('active'));
    button.classList.add('active');
};

coffeeBtn.addEventListener('click', showCoffeeMenu);
teaBtn.addEventListener('click', showTeaMenu);
dessertBtn.addEventListener('click', showDessertMenu);

// default category
showCoffeeMenu();

// window.onload = () => {
//     alert('Уважаемые проверяющие во вторник, убедительная просьба дать день отсрочки, так как функционал модальных окон еще не закончен, заранее спасибо!')
// }

//modals
const modal = document.querySelector('.menu__modal');
const modalImage = document.querySelector('.menu__modal-img');
const modalTitle = document.querySelector('.menu__modal-title');
const modalText = document.querySelector('.menu__modal-text');
const menuClosebtn = document.querySelector('.menu__modal-closebtn');
const modalSizeButtons = document.querySelectorAll('.menu__modal-size-btn');
const modalSizeNames = document.querySelectorAll('.menu__modal-size-name');
const modalAdditivesButtons = document.querySelectorAll('.menu__modal-additives-btn');
const modalAdditivesSelectors = document.querySelectorAll('.menu__modal-additives-select');
const total = document.querySelector('.menu__modal-total-check');
const cards = document.querySelectorAll('.menu__card');
let sizeButtons;

menuClosebtn.addEventListener('click', () => {
    modalClose();
    noScrollRemove();
});

modal.addEventListener('click', (event) => {
    if (event.target === modal) {
        modalClose();
        noScrollRemove();
    }
});

function initCardEventListeners() {
    const cards = document.querySelectorAll('.menu__card');

    cards.forEach((card, index) => {
        card.removeEventListener('click', handleCardClick);
        card.addEventListener('click', () => handleCardClick(index));
    });
}

function handleCardClick(index) {
    const filteredItems = allMenuItems.filter(item => item.category === currentCategory);
    const selectedItem = filteredItems[index];

    if (selectedItem) {
        modalImage.src = selectedItem.photo;
        modalTitle.textContent = selectedItem.name;
        modalText.textContent = selectedItem.description;

        sizeButtons = document.querySelectorAll('.menu__modal-size-btn');
        sizeButtons.forEach((button, i) => {
            const sizes = Object.entries(selectedItem.sizes);
            const sizeKey = sizes[i][0];
            const sizeValue = sizes[i][1].size;

            button.innerHTML = `<span class="menu__modal-size-name">${sizeKey.toUpperCase()}</span>${sizeValue}`;
            button.dataset.dataprice = sizes[i][1]['add-price'];
            button.dataset.size = sizeKey;
        });

        handleSizeButtons();

        const additivesButtons = document.querySelectorAll('.menu__modal-additives-btn');
        additivesButtons.forEach((button, i) => {
            button.innerHTML = `<span class="menu__modal-additives-select">${i + 1}</span>${selectedItem.additives[i].name}`;
            button.dataset.dataprice = selectedItem.additives[i]['add-price'];
        });
        handleAdditivesButtons();
        const total = document.querySelector('.menu__modal-total-check');
        total.textContent = `$${selectedItem.price}`;
        
        modalOpen();
        noScrollAdd();
    }
}

function setActiveSizeButton(size, sizes, button) {
    const sizeButtons = document.querySelectorAll('.menu__modal-size-btn');
    const sizeNames = document.querySelectorAll('.menu__modal-size-name');

    sizeButtons.forEach((btn, i) => {
        const sizeName = sizeNames[i];

        if (btn.dataset.size === size) {
            btn.classList.add('active');
            sizeName.classList.add('active');
        } else {
            btn.classList.remove('active');
            sizeName.classList.remove('active');
        }
    });

    setBasePrice(button);
    setSizePrice(button);
    updatePrice();
}

// function handleSizeButtons(sizes) {
//     sizeButtons.forEach((button) => {
//         button.addEventListener('click', (event) => {
//             const selectedSize = event.currentTarget.dataset.size;
//             setActiveSizeButton(selectedSize, sizes, button); // Передача button в setActiveSizeButton
//         });
//     });
// }

function setBasePrice(button) {
    const selectedItem = menuItems[0];
    const size = button.dataset.size;

    if (selectedItem.sizes[size]) {
        price = parseFloat(selectedItem.price);
    }
}

function setSizePrice(button) {
    const selectedItem = menuItems[0];
    const size = button.dataset.size;

    if (selectedItem.sizes[size]) {
        sizePrice = parseFloat(selectedItem.sizes[size]["add-price"]);
    }
}

function handleSizeButtons(sizes) {
    sizeButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            if (!event.currentTarget.classList.contains('active')) {
                setActiveSizeButton(event.currentTarget.dataset.size, sizes, event.currentTarget);
                setBasePrice(event.currentTarget);
                setSizePrice(event.currentTarget);
                updatePrice();
            }
        });
    });
}

function handleAdditivesButtons() {
    const modalAdditivesButtons = modal.querySelectorAll('.menu__modal-additives-btn'); // Найти кнопки добавок внутри модального окна

    modalAdditivesButtons.forEach((button) => {
        button.addEventListener('click', () => {
            toggleActiveClass(button);
            updateAdditivePrice(button);
            updatePrice();
        });
    });
}

function updateAdditivePrice(button) {
    const additivePriceValue = +button.dataset.dataprice;
    if (button.classList.contains('active')) {
        additivePrice += additivePriceValue;
    } else {
        additivePrice -= additivePriceValue;
    }
}

function addAdditivePrice(button) {
    additivePrice += +button.dataset.dataprice;
}

function removeAdditivePrice(button) {
    additivePrice -= +button.dataset.dataprice;
}

let price = 0;
let sizePrice = 0;
let additivePrice = 0;

function updatePrice() {
    const totalPrice = price + sizePrice + additivePrice;
    total.textContent = `$${totalPrice.toFixed(2)}`;
}

initCardEventListeners();

function modalOpen() {
    modal.classList.add('active');
}
function modalClose() {
    modal.classList.remove('active');
}
function noScrollAdd() {
    document.body.classList.add('noscroll');
}
function noScrollRemove() {
    document.body.classList.remove('noscroll');
}
function toggleActiveClass(element) {
    element.classList.toggle('active');
}